import {
    WHOLESALE_ORDER_SUCCESS,
    WHOLESALE_ORDER_LOADING,
  } from '../actions/WholesaleOrderAction';
  
  const initialState = {
    orderData: [],
    isLoading: true
  };
  
  const WholesaleOrderReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case WHOLESALE_ORDER_SUCCESS:
        return { ...state, orderData: action.data, isLoading: false };
      case WHOLESALE_ORDER_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default WholesaleOrderReducer;
  